import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

const secondsToMinutes = (seconds: number): number => {
  return Math.round(seconds / 60);
};

@Component({
  selector: 'osn-shared-progress-bar',
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    role: 'progressbar',
    'aria-valuemin': '0',
    tabindex: '0',
  },
})
export class ProgressBarComponent {
  @Input() @HostBinding('attr.aria-valuemax') public lengthInSeconds = 1;
  @Input() @HostBinding('attr.aria-valuenow') public elapsedInSeconds = 1;
  @Input() public showProgressMinutes = false;
  @Input() public theme: 'pink' | 'white' = 'pink';
  @HostBinding('attr.aria-valuetext') public get ariaValueText(): string {
    return `You watched ${secondsToMinutes(this.elapsedInSeconds)} minutes of ${secondsToMinutes(this.lengthInSeconds)}.`;
  }
  public get remainingMinutes(): number {
    return secondsToMinutes(this.lengthInSeconds - this.elapsedInSeconds);
  }
  public get progressInPercentage(): number {
    const percentage = 100;
    return Math.min((this.elapsedInSeconds / this.lengthInSeconds) * percentage, percentage);
  }
}
